<template>
    <div>
      <div class="title">
        <div class="container">
          <div class="row justify-content-center align-items-center">
            <div class="col-lg-7 col-md-6 text-center hvr-bob">
                <img class="img-fluid" data-aos="fade-down" src="images/headline.png" alt="headline">
            </div>
            <div class="col-lg-5 col-md-6">
                <h1 class="text-md-left text-center" data-aos="fade-up">Transaksi
                <span class="ml-lg-5 ml-md-0">Keperluan</span>
                Apapun #SemuaBisa</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
      name: "Slideshow"
    }
</script>

<style scoped>

</style>